import { useFormik } from "formik";
import * as Yup from "yup";
// import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { insertInquiry } from "./services/tour.services";
import { ErrorToast } from "../../toast/Toasts";

const TourInquiryModel = ({
  setClose,
  data,
}: {
  setClose: any;
  data?: any;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.tour.loading);

  const formik: any = useFormik({
    initialValues: {
      FirstName: "",
      LastName: "",
      EmailID: "",
      MobileNo: "",
      Remarks: "",
    },
    validateOnBlur: true,
    validationSchema: Yup.object({
      FirstName: Yup.string().trim().required("FirstName is required"),
      LastName: Yup.string().trim().required("LastName is required"),
      MobileNo: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
      EmailID: Yup.string()
        .required("Email is required")
        .test("is-email-required", "Email is not valid", function (value) {
          if (!value) {
            return true;
          }
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailRegex.test(value);
        }),
    }),
    onSubmit: async (
      values,
      {
        // setSubmitting,
        resetForm,
      }
    ) => {
      const payload = {
        FirstName: values?.FirstName ? values?.FirstName : "",
        LastName: values?.LastName ? values?.LastName : "",
        EmailID: values?.EmailID ? values?.EmailID : "",
        MobileNo: `${values?.MobileNo}`,
        Remarks: values?.Remarks ? values?.Remarks : "",
        URL: data?.TourURL ? data?.TourURL : "",
      };
      const response = await dispatch(insertInquiry(payload));
      if (response.meta.requestStatus === "fulfilled") {
        navigate("/thankyou/");
        setClose(false);
        resetForm();
      } else {
        ErrorToast("Error sending message!");
      }
    },
  });

  return (
    <div>
      <div className="tourinquirymodel">
        <div className="popup">
          {/* <h2 className="mb-3">Book This Tour</h2> */}
          <form onSubmit={(e) => formik.handleSubmit(e)} className="">
            <div className="field-set lead-form">
              <div className="d-flex gap-2 mb-2">
                <div className="field">
                  <label
                    className={
                      formik.errors.FirstName && formik.touched.FirstName
                        ? "error-label"
                        : ""
                    }
                  >
                    First Name
                  </label>
                  <input
                    name="FirstName"
                    type="text"
                    placeholder="Enter Your First Name*"
                    className={`fields flex-3 ${
                      formik.errors.FirstName && formik.touched.FirstName
                        ? "error-field"
                        : ""
                    }`}
                    maxLength={50}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values?.FirstName}
                  />
                </div>
                <div className="field">
                  <label
                    className={
                      formik.errors.LastName && formik.touched.LastName
                        ? "error-label"
                        : ""
                    }
                  >
                    Last Name
                  </label>
                  <input
                    name="LastName"
                    type="text"
                    placeholder="Enter Your Last Name*"
                    className={`fields flex-2 ${
                      formik.errors.LastName && formik.touched.LastName
                        ? "error-field"
                        : ""
                    }`}
                    maxLength={50}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values?.LastName}
                  />
                </div>
              </div>
              <div className="field mb-2">
                <label
                  className={
                    formik.errors.EmailID && formik.touched.EmailID
                      ? "error-label"
                      : ""
                  }
                >
                  Email ID
                </label>
                <input
                  type="email"
                  name="EmailID"
                  id="EmailID"
                  placeholder="Enter Your Email ID*"
                  className={`${
                    formik.errors.EmailID && formik.touched.EmailID
                      ? "error-field"
                      : ""
                  }`}
                  maxLength={50}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values?.EmailID}
                />
              </div>
              <div className="field mb-2">
                <label
                  className={
                    formik.errors.MobileNo && formik.touched.MobileNo
                      ? "error-label"
                      : ""
                  }
                >
                  Mobile No.
                </label>
                <input
                  id="MobileNo"
                  name="MobileNo"
                  type="number"
                  className={`${
                    formik.errors.MobileNo && formik.touched.MobileNo
                      ? "error-field"
                      : ""
                  }`}
                  placeholder="Enter Your Mobile No.*"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values?.MobileNo}
                  onInput={(e: any) => {
                    return (e.target.value = Math.max(
                      0,
                      parseInt(e.target.value)
                    )
                      .toString()
                      .slice(0, 10));
                  }}
                />
              </div>
              <div className="field mb-2">
                <label>Remarks</label>
                <textarea
                  name="Remarks"
                  id="Remarks"
                  placeholder="Enter Your Message"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values?.Remarks}
                />
              </div>
            </div>
            {/* <div className="d-flex gap-2 mt-2">
              <input
                className="btn gradiant-btn"
                type="submit"
                defaultValue="Submit"
                disabled={
                  // formik.errors.MobileNo ||
                  // formik.values.MobileNo?.length < 10 ||
                  loading
                }
              />
              <input
                className="btn border-btn"
                type="button"
                defaultValue="Cancel"
                onClick={() => {
                  formik.resetForm();
                  setClose(false);
                }}
              />
            </div> */}
            <div className="inquiry-btns mt-3 text-end">
              <a
                className="disable"
                href=" "
                data-bs-dismiss="modal"
                onClick={(e) => {
                  e.preventDefault();
                  formik.resetForm();
                  setClose(false);
                }}
              >
                Cancel
              </a>
              <a
                href="javascript:void(0)"
                onClick={(event) => {
                  event.preventDefault();
                  formik.handleSubmit();
                }}
              >
                Save
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TourInquiryModel;
